import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
	root: {
		maxWidth: '80%',
		minHeight: '100%',
		marginLeft: '50px',
		marginBottom: '100px',
	},
	button: {
		marginLeft: '40%',
	},
});
